import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { FeatureFlags } from '@centric-os/types';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { SitesRouteNames } from '@centric-os/sites';

export const beforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const splitIoStore = useSplitIoStore();

  try {
    if (splitIoStore.isFeatureOn(FeatureFlags.VOUCHERIFY_REPLACEMENT)) {
      next();
    } else {
      next({ name: SitesRouteNames.SITES_LIST, replace: true });
    }
  } catch (error) {
    console.error('Error during navigation guard execution:', error);
    next(false);
  }
};
